<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="商品价格"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:`/goods-price/${goodsId}`,breadcrumbName:'商品价格'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!goodsId"
        >
          <a-icon type="appstore"/>
          相关价格
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button type="primary" @click="addPrice">
          {{ $t('ADD') || '添加' }}
        </a-button>
        <a-button @click="onCancel">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <a-spin :spinning="form.loading">
      <div style="margin: 16px">
        <a-card>
          <a-table
            :data-source="table.data"
            ref="dragTable"
            row-key="id"
            :columns="table.columns"
          >
             <span slot="action" slot-scope="text, record">
               <a-button type="link" @click="editPrice(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
               <a-button type="link" @click="deletePrice(record.id)">{{ $t('DELETE') || '删除' }}</a-button>
             </span>
            <template slot="sort">
              <a-icon type="drag"  style="font-size: 25px;"/>
            </template>
          </a-table>
        </a-card>
      </div>
    </a-spin>
    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="form.visible">
      <goods-price-edit
        v-if="form.visible"
        :goods-price-id="form.data.id"
        :goods-id="this.goodsId"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  _queryPriceByGoodsId,
  _deletePrice,
  _updateGoodsSort,
} from '@/api/websiteGoodsPriceApi';
import GoodsPriceEdit from './GoodsPriceEdit.vue';
import Sortable from 'sortablejs';

async function getGoodsPriceList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryPriceByGoodsId({
    goodsId: this.goodsId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function onCancel() {
  this.$router.go(-1);
}

function addPrice() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editPrice(id) {
  this.form.data.id = id;
  this.form.visible = true;
}

function deletePrice(id) {
  this.$confirm({
    title: '是否删除',
    content: '',
    onOk: async () => {
      await _deletePrice(id);
      this.$message.success('删除成功');
      await this.getGoodsPriceList();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsPriceList();
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getGoodsPriceList();
  }
}

function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(4)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },
  })
}

const columns = [
  {
    title: 'key',
    dataIndex: 'paramKey',
  },
  {
    title: 'value',
    dataIndex: 'paramValue',
  },
  {
    title: 'country',
    dataIndex: 'country',
  },
  {
    title: '拖拽排序',
    dataIndex: 'id',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'GoodsPriceList',
  props: {
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  components: { GoodsPriceEdit },
  data() {
    return {
      searchName: '',
      table: {
        columns,
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
      form: {
        loading: false,
        visible: false,
        data: {
          id: '',
        },
        rules: {
          key: [{
            required: true,
            trigger: 'blur',
          }],
          value: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    }
  },
  methods: {
    getGoodsPriceList,
    deletePrice,
    editPrice,
    addPrice,
    closeForm,
    onCancel,
    updateSortList,
    initSortable,
  },
  mounted() {
    this.initSortable();
  },
  async created() {
    if (this.goodsId) {
      await this.getGoodsPriceList()
    }
  },
}
</script>

<style scoped>

</style>
